import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { Client } from '../../admin/users/types';

export type CreateClientPayload = {
  emailAddress?: string | null;
  firstName: string;
  middleName?: string;
  lastName: string;
  advisorUserId: string;
  familyId?: string;
};

export function useCreateClient() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<{ data: Client }, Error, CreateClientPayload>({
    mutationFn: (values: CreateClientPayload) => api.post<Client>('clients', values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const createClient = async (values: CreateClientPayload) => {
    return mutateAsync({
      ...values,
      firstName: values.firstName.trim(),
      middleName: values.middleName?.trim() || undefined,
      lastName: values.lastName.trim(),
    });
  };

  return {
    createClient,
    error,
    isLoading,
    reset,
  };
}
